import Grid from '@mui/material/Unstable_Grid2';
import { RELATION_PART_OF } from '@backstage/catalog-model';
import { EntityLayout } from '@internal/plugin-medidata-catalog-react';
import { commonContent, maturityScoreContent } from './commonContent';

export const mobileEntityPage = (
  <EntityLayout parentEntityRelations={[RELATION_PART_OF]}>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={1} alignItems="stretch">
        {commonContent}
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/maturity" title="Maturity">
      {maturityScoreContent}
    </EntityLayout.Route>
  </EntityLayout>
);
